import { createContext, useState, useContext } from 'react'

import { getUser, getTheme } from './constants'

const ProfileContext = createContext()

const Profile = ( {
  children
} ) => {
  const [ user, setUser ] = useState( getUser() )
  const [ themeParams, setThemeParams ] = useState( getTheme() )

  return <ProfileContext.Provider
    value={ {
      user,
      themeParams
    } }
  >
    { children }
  </ProfileContext.Provider>
}

const withProfile = ( ComponentAlias ) => {
  return props => <ProfileContext.Consumer>
    { context => <ComponentAlias { ...props } withProfile={ context } /> }
  </ProfileContext.Consumer>
}

const useProfile = () => {
  const context = useContext( ProfileContext )

  if ( ! context )
    throw new Error( 'useProfile must be used with Profile provider' )

  return context
}

export {
  withProfile,
  ProfileContext,
  useProfile
}

export default Profile
